import styled from 'styled-components';

const CommentSeparator = styled.div`
    margin: 18px -1px 18px -10px;
    border-top: solid 1px #e9e9e9;
`;
CommentSeparator.displayName = 'CommentSeparator';

export default CommentSeparator;
